import { text } from "@antv/x6/lib/util/dom/text";

export default {
  CapMultiSelect: {
    noResultsFoundText: "No results found",
    selectText: "Select",
    closeText: "Close",
    searchPlaceholder: "Search",
    selectedText: "selected",
    selectAllText: "Select all",
    selectAllSearchResultsText: "Select all searched results",
    moreText: "more",
  },
  CapModal: {
    okText: 'Yes',
    closeText: 'No',
  },
  CapMultiSelectWithTree: {
    noResultsFoundText: "No results found",
    selectText: "Select",
    closeText: "Close",
    searchPlaceholder: "Search",
    selectedText: "selected",
    selectAllText: "Select all",
    selectAllSearchResultsText: "Select all searched results",
    moreText: "more",
    storeUploadsText: "Store IDs are uploaded already",
  },
  CapCustomSelect: {
    searchPlaceholder: 'Search',
    selectPlaceholder: 'Select Option',
  },
  CapMultiSelectDatePicker: {
    lastDayText: 'Last day of month',
  },
  CapTable: {
    loadMoreData: 'Loading more data...',
  },
  CapIllustration: {
    accessForbiddenMsg: 'Action cannot be performed due to insufficient permission',
  },
  CapNavigation: {
    businessProcesses: 'Workbench',
    wecrm: 'Wecrm',
    loyaltyProgram: 'Loyalty+',
    storePerformance: 'Store Performance',
    memberCare: 'Member Care',
    storeCare: 'Store Care',
    insights: 'Insights+',
    connectPlus: 'Connect+',
    settingsLabel: 'Settings',
    campaign: 'Engage+',
    selectOrganization: 'Select Organization',
    organization: 'Organization',
    noResultText: 'No results found',
    selectProduct: 'Select Product',
  },
  InfoNote: {
    noteText: 'Note',
  },
  SomethingWentWrong: {
    title: 'Sorry, something went wrong.',
    description: 'Please try again. If this issue occurs again, please reach out to Capillary support team.',
    reloadText: 'Try refreshing again',
  },
  CapBlock: {
    deleteBlockMsg: 'Delete',
    expandBlockMsg: 'Expand',
    collapseBlockMsg: 'Collapse',
  },
  CapMultiplePath: {
    notUniqueMsg: 'Not Unique',
    deleteConfirmationTitleMsg: 'Confirm delete path',
    deleteConfirmationTextMsg: 'Are you sure you wish to delete path',
    deleteConfirmationWarningMsg: 'This action cannot be undone.',
    deleteButtonTextMsg: 'Yes, Delete',
    yesMsg: 'Yes',
    noMsg: 'No',
    pathMsg: 'Path',
    addPathMessage: 'Add Path',
  },
  CapCondition: {
    includeMsg: 'include',
    excludeMsg: 'exclude',
    equalMsg: 'equal to',
    greaterThanMsg: 'greater than',
    lessThanMsg: 'less than',
    greaterThanOrEqualMsg: 'greater than or equal to',
    lessThanorEqualMsg: 'less than or equal',
    inRangeMsg: 'in range',
    notEqualMsg: 'not equal to',
    whoseMsg: 'Whose',
    isMsg: 'is',
    andMsg: 'and',
    ANDMsg: 'AND',
    containsMsg: 'contains',
    startsWithMsg: 'starts with',
    endsWithMsg: 'ends with',
    exactMsg: 'exact',
    conditionStringInputPlaceholderMsg: 'Enter min. 3 characters',
    lineItemMsg: 'only for lineitems with',
    withMsg: 'with',
    additionalFieldsMsg: 'Additional condition',
    plusMinus: '+/-',
    inMsg: 'in',
    notInMsg: 'not in',
    uploadFailedError: 'Upload failed',
    uploadLimitExceeded: 'Please do not upload more than 1000 store codes',
    uploadReqLoader: 'Uploading stores',
    or: 'OR',
    search: 'Search',
    searchWithExact: 'Search with exact keyword',
    customFieldsTag: 'custom fields',
    storeSearchMsg: 'Enter min. 3 characters to search',
    uploadInProgressMsg: 'Upload in progress',
    unsupportedCsvHeaderMsg: 'The CSV header must be ‘Store code’ or ‘Store id’',
    csvFileNoEntryTxt: "Please upload a file with atleast one entry",
    downloadedMsg: "downloaded",
    reuploadFileMsg: 'Reupload file',
    storeIdsMsg: 'Store IDs',
    downloadStoreIdMsg: 'Download Store ID',
    downloadStoreIdCodeNameMsg: 'Download Store ID, code & name',
    downloadInProgressMsg: 'Download in progress, might take a while',
  },

  CapConditionPreview: {
    includeMsg: 'Include',
    excludeMsg: 'Exclude',
    equalMsg: 'equal to',
    greaterThanMsg: 'greater than',
    lessThanMsg: 'less than',
    greaterThanOrEqualMsg: 'greater than or equal to',
    lessThanorEqualMsg: 'less than or equal',
    inRangeMsg: 'in range',
    notEqualMsg: 'not equal to',
    whoseMsg: 'whose',
    isMsg: 'is',
    andMsg: 'and',
    ANDMsg: 'AND',
    lineItemMsg: 'only for lineitems with',
    withMsg: 'with',
    addedSKUsMsg: 'Added SKUs',
    skuFileName: 'SKU.csv',
    uploadedMsg: 'uploaded',
    inMsg: 'in',
    notInMsg: 'not in',
    storesMsg: 'Stores',
    viewMoreMsg: 'View more',
    uploadInProgressMsg: 'Upload in progress',
    uploadFailedErrorMsg: 'Upload failed',
    uploadInvalidErrorMsg: 'Invalid file uploaded',
  },
  CapPopoverTree: {
    emptyDataMessage: 'No data found',
    searchPlaceholder: 'Search',
  },
  CapGraphBlockNode: {
    configureText: 'Configure',
    replaceEngagementBlockMsg: 'Replace engagement block',
  },
  CapStaticTemplates: {
    strategyTitleMsg: 'Select the strategy',
    strategyDescriptionMsg: 'Use strategy driven pre-defined marketing use-cases or build your own strategy',
    comingSoonMsg: 'Coming soon',
    blankCategoryLabel: 'Custom',
    blankTemplateLabel: 'Build from scratch',
    blankTemplateDescription: 'Create your own journey from scratch',
    searchPlaceholderMsg: 'Search strategy',
  },

  CapProductSelection: {
    lineItem: 'Line items',
    selectAttribute: 'Select Attribute',
    brand: 'Brand',
    brandInfo: 'Brand',
    category: 'Category',
    categoryInfo: 'Category',
    product: 'Product',
    productInfo: 'Product',
    SKU: 'SKU',
    uploadSKU: 'Upload SKU',
    uploadSKUInfo: 'Upload SKU',
    changeSelection: 'Change the selection',
    description: 'Changing the attribute of additional condition will result in lose of previously defined additional condition',
    okText: 'Yes, change',
    cancelText: 'Cancel',
    comingSoon: 'Coming soon',
    selectValues: 'Select value(s)',
    atleast1Attribute: 'At least 1 attribute is required',
  },
  CapTruncateList: {
    more: 'more',
  },
  CapSKUUploader: {
    validatingSKUs: 'Validating SKUs',
    invalid: 'invalid',
    invalidSKUs: 'Invalid SKUs',
    valid: 'valid',
    addedSKUsMsg: 'Added SKUs',
    skuFileName: 'SKU.csv',
    invalidSKUFilename: 'invalidSKU.csv',
    uploadedMsg: 'uploaded',
  },
  CapDndGraph: {
    deleteBlockModalHeaderText: 'Delete block',
    deleteBlockModalDescriptionText: 'Are you sure you want to delete this block?',
    yesDeleteButtonText: 'Yes, delete',
    noButtonText: 'No',
    joinDropErrorText: "Join block can only be added at the end of the path",
    jumpDropErrorText: "Jump block can only be added at the end of the path",
    theText: 'The',
    endText: 'End',
    blockIsLinkedText: 'block is linked to the',
    blockText: 'block.',
    disconnectText: 'Deleting this block will disconnect the join.',
    areYouSureText: 'Are you sure?',
  },
  CapDragAndDrop: {
    dropboxtext: 'Drop here!',
    selectFilesText: 'Select files from your computer',
    invalidFileSelectionText: 'Invalid file selection!',
    or: 'OR',
    droptext: 'Drag and drop files',
  },
  CapRoadMap: {
    defaultRoadMapDisabledMessage: "Not configured yet",
  },
  CapTimelineCard: {
    defaultConfiguringMessage: 'Configuring...',
    defaultNotConfiguredMessage: 'Not configured yet...',
    toConfigure: 'To configure ',
    completePrevSteps: ' complete the previous steps.',
  },
  CapTimelineNestedCard: {
    defaultConfiguringMessage: 'Configuring...',
    defaultNotConfiguredMessage: 'Not configured yet...',
    toConfigure: 'To configure ',
    completePrevSteps: ' complete the previous steps.',
  },
  NestedCardParent: {
    defaultNestedTitle: 'Triggers',
    toConfigure: 'To configure ',
    completePrevSteps: ' complete the previous steps.',
  },
  'CapAskAira.DocumentationBot': {
    textAskYourQuestion: "Ask your question here",
    textVisitDocs: "Visit Capillary Documentation",
    textNeedHelp: "Need more help?",
    textHowMayIHelp: "How may AI help you?",
    textAira: "AiRA Documentation Bot",
    textLinks: "Links",
    textWasHelpful: "Was this response helpful?",
    textConfidence: "confidence",
    textTooltip: "Need help? Ask Aira",
    textCantConnect: "Can't connect to the server.",
  },
  'CapAskAira.RuleGenerationBot': {
    textTypeAMessage: 'Type a message above and ask AiRA to recommend the best content',
    textError: "An error occurred while generating rule. Try again.",
    textAiraTitle: "AiRA Rule Generation",
    textAiraTooltip: "AiRA, our proprietary AI tool, generates rule expressions based on text query.",
    textCopy: "Copy",
    textCopied: "Copied",
    textRulePlaceholder: "Enter query...",
    textRuleLoading: "Rule is loading... Hang tight!",
    textThank: 'Thank you for your response!',
    textWarn: 'Aira responses may be inaccurate or misleading. Help us to improve!',
    textAddCommentPlaceholder: 'Add comment',
  },
  'CapAskAira.ContentGenerationBot': {
    textTypeAMessage: 'Type a message above and ask AiRA to recommend the best content',
    textRecommendationsLoading: "Recommendations loading... Hang tight!",
    textError: "An error occurred while loading recommendations. Try again.",
    textAiraTitle: "AiRA Content Recommendations",
    textAiraTooltip: "AiRA, our proprietary AI tool, recommends tailored language to effectively engage customers and prompt desired actions.",
    textLoading: "loading...",
    textCharacters: "characters",
    textReplaceWithThis: "Replace with this",
    textReplaced: 'Replaced',
    textResetToDefault: "Reset to default",
    textMoreLikeThis: "More like this",
    textGenerateMore: "Generate more",
  },
  'CapAskAira.ConfigurationBot': {
    textAiraTitle: 'Aira Configuration Bot',
    textAiraTooltip: "Aira, our proprietary AI tool, helps you configure promotions, campaigns, and more.",
    textTypeAMessage: 'Type a message above and ask AiRA to recommend the best content',
    textUser: 'Hello!',
    textPilot: "I'm your Copilot. I can create all type of promotions (milestones, streaks, etc.) on your behalf. Meanwhile, you can sit back, relax, and enjoy a cup of chai.",
    textCouponTile: 'Milestone on GS',
    textCouponDescription: 'Customer has to do 1000/- gross sales in a month, and can get 100 points.',
    textPromotionTitle: 'Milestone on count',
    textPromotionDescription: 'Eligible customers get points on every 5 transactions.',
    textStreakTitle: 'Reward on referral',
    textStreakDescription: 'Award customer 150 points if they refer 3 users in a month. Promotion starts on July 1 and runs for 5 months.',
    textPromptHere: 'Enter a prompt here...',
    textCouponPrompt: 'If customer does 1000 gross sales in a month, award them 100 points that expire in 20 days. Promotion runs from 1 July to 1 December.',
    textPromotionPrompt: 'After every 5 transactions I want to award customer with 200 points. Only customers with more than 2000 lifetime points are eligible. Promotion runs from 1 July to 1 December',
    textStreakPrompt: 'Award customer 150 points if they refer 3 users in a month. Promotion starts on July 1 and runs for 5 months. ',
    textCantConnect: "Can't connect to the server.",
    textCreate: 'Create',
    textCancel: 'Cancel',
    textGeneratingResponse: 'Generating response',
  },
  'CapAskAira.DocumentationChatBot': {
    textBotPlaceholder: 'Ask Aira about anything on our CRM platform',
    textChatBotLoader: 'Hang tight, analyzing your query...',
    textChatBotDesc: 'Ask any doubts about our CRM platform and Aira will do its best to find answers',
    textChatBot: 'Documentation Chat Bot'
  },
  'CapAskAira.CapAiMediaGeneration': {
    textImageBotPlaceholder: 'Ask Aira to generate an image',
    textChatBotLoader: 'Hang tight, analyzing your query...',
    textImageBotDesc: 'Enter a prompt that describes your image.',
    textImageBot: 'Aira Media Generator',
    textImageFooter: 'Dragging and dropping generated images is only supported in the basic email builder.',
    textTipsGenerate: 'Tips to generate better images:',
    textCopy: 'Copy image',
    textCopied: 'Copied',
    textDownload: 'Download',
    textImageDownload: 'Image downloaded successfully!',
    textComingSoon: 'Coming soon',
    textGenerateMore: 'Generate more',
  },
  'CapAskAira.RuleSummarizationBot': {
    textRuleBotPlaceholder: 'Ask Aira to write an expression',
    textSummarizeBotPlaceholder: 'Ask Aira to explain an expression',
    textRuleChatBotLoader: 'Hang tight, analyzing your query...',
    textRuleChatBotDesc: 'Write your detailed rule in simple english and Aira will write the expression for you',
    textSummarizeChatBotDesc: 'Enter the expression and Aira will generate a summary in plain english',
    textRuleChatBot: 'Aira Expression Translator'
  }
};

